import type { MetaCallToAction } from '../../types/metaAdDraft';

// All 18 MetaCallToAction values with human labels for the CTA dropdown (C7.2).
// Order: the common Lead Gen / Traffic picks first, then the rest.
export const CTA_OPTIONS: { value: MetaCallToAction; label: string }[] = [
  { value: 'SIGN_UP', label: 'Sign Up' },
  { value: 'LEARN_MORE', label: 'Learn More' },
  { value: 'GET_OFFER', label: 'Get Offer' },
  { value: 'GET_QUOTE', label: 'Get Quote' },
  { value: 'BOOK_TRAVEL', label: 'Book Now' },
  { value: 'CONTACT_US', label: 'Contact Us' },
  { value: 'SUBSCRIBE', label: 'Subscribe' },
  { value: 'REGISTER', label: 'Register' },
  { value: 'APPLY', label: 'Apply Now' },
  { value: 'REQUEST_DEMO', label: 'Request Demo' },
  { value: 'JOIN', label: 'Join' },
  { value: 'ATTEND', label: 'Attend' },
  { value: 'SHOP_NOW', label: 'Shop Now' },
  { value: 'BUY_NOW', label: 'Buy Now' },
  { value: 'DOWNLOAD', label: 'Download' },
  { value: 'WATCH_MORE', label: 'Watch More' },
  { value: 'SEE_MORE', label: 'See More' },
  { value: 'VIEW_QUOTE', label: 'View Quote' },
];

export function ctaLabel(value: MetaCallToAction): string {
  return CTA_OPTIONS.find((o) => o.value === value)?.label ?? value;
}
